import moment from 'moment';
import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import FileSaver from 'file-saver';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import WhseJob030102Actions, { WhseJob030102Types } from '../Stores/WhseJob030102/Actions';

const getAppStore = state => state.app;

export function* whseJob030102FetchWhseJob030102({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(WhseJob030102Actions.whseJob030102FetchWhseJob030102Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `whseJob/indexProcess/WHSE_JOB_03_01_02/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        WhseJob030102Actions.whseJob030102FetchWhseJob030102Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(WhseJob030102Actions.whseJob030102FetchWhseJob030102Loading(false));
  }
}

export function* whseJob030102PrintWhseJob030102({ hdrIds }) {
  try {
    yield put(WhseJob030102Actions.whseJob030102PrintWhseJob030102Loading(true));

    const app = yield select(getAppStore);

    const getData = {
      hdrIds
    };

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `whseJob/printProcess/WHSE_JOB_03_01_02/${app.curSiteFlowId}`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      const selectedDocuments = hdrIds.map(d => ({ id: d }));

      FileSaver.saveAs(result.data, 'PickListWhseJob.pdf');
      yield put(WhseJob030102Actions.whseJob030102RemoveSelectedDocuments(selectedDocuments));
      yield put(WhseJob030102Actions.whseJob030102ResetTimestamp());
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(WhseJob030102Actions.whseJob030102PrintWhseJob030102Loading(false));
  }
}

export function* whseJob030102GoToWhseJobDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/whseJob03Detail/update/${hdrId}`));
}

export function* whseJob030102DownloadExcel() {
  try {
    yield put(WhseJob030102Actions.whseJob030102FetchWhseJob030102Loading(true));

    const app = yield select(getAppStore);

    const getData = {};

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `whseJob/downloadWhseJob030102/${app.curSiteFlowId}`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      FileSaver.saveAs(
        result.data,
        `WIP_PICK_LIST_JOB_${moment(new Date()).format('YYYY_MM_DD_HH_mm_ss')}.XLSX`
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(WhseJob030102Actions.whseJob030102FetchWhseJob030102Loading(false));
  }
}

export const saga = [
  takeLatest(
    WhseJob030102Types.WHSE_JOB030102_FETCH_WHSE_JOB030102,
    whseJob030102FetchWhseJob030102
  ),
  takeLatest(
    WhseJob030102Types.WHSE_JOB030102_PRINT_WHSE_JOB030102,
    whseJob030102PrintWhseJob030102
  ),
  takeLatest(
    WhseJob030102Types.WHSE_JOB030102_GO_TO_WHSE_JOB_DOCUMENT,
    whseJob030102GoToWhseJobDocument
  ),
  takeLatest(WhseJob030102Types.WHSE_JOB030102_DOWNLOAD_EXCEL, whseJob030102DownloadExcel)
];
